module.exports = __webpack_public_path__ + "static/media/right-arrow.7d9dcd5c.png";